import { render } from "./pageEle.vue?vue&type=template&id=a0cf5842&scoped=true"
import script from "./pageEle.vue?vue&type=script&lang=js"
export * from "./pageEle.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0cf5842"]])

export default __exports__